import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoaderService } from './loader.service';

@NgModule({
  imports: [CommonModule],
  providers: [LoaderService],
})
export class LoaderModule {}
